var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrevo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.262C11.97 5.562 13.5 4.176 13.5 2.421C13.5 1.071 12.375 0 11.025 0C10.251 0 9.513 0.324 9 0.9C8.487 0.324 7.749 0 6.921 0C5.571 0 4.5 1.125 4.5 2.475C4.5 4.176 6.03 5.562 9 8.262ZM8.262 9C5.562 6.03 4.176 4.5 2.421 4.5C1.071 4.5 0 5.625 0 6.975C0 7.749 0.324 8.487 0.9 9C0.324 9.513 0 10.251 0 11.079C0 12.429 1.125 13.5 2.475 13.5C4.176 13.5 5.562 11.97 8.262 9ZM9.747 9C12.438 11.97 13.824 13.5 15.579 13.5C16.929 13.5 18 12.375 18 11.025C18 10.251 17.676 9.513 17.1 9C17.676 8.487 18 7.749 18 6.921C18 5.571 16.875 4.5 15.525 4.5C13.824 4.5 12.438 6.03 9.747 9ZM9 9.738C6.03 12.438 4.5 13.824 4.5 15.579C4.5 16.929 5.625 18 6.975 18C7.749 18 8.487 17.676 9 17.1C9.513 17.676 10.251 18 11.079 18C12.429 18 13.5 16.875 13.5 15.525C13.5 13.824 11.97 12.438 9 9.738Z",
    fill: "#4ECB71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrevo);
export default __webpack_public_path__ + "static/media/icon_trevo.e2f9b6dfa9d53cd20078e905bc6036f8.svg";
export { ForwardRef as ReactComponent };